<template>
  <ItemRow
    v-bind="$attrs"
    :selected="itemData.selected"
    v-on="$listeners"
  >
    <ItemWithLabel
      v-for="(column, index) in columns"
      :key="index"
      :column="column"
    >
      <span
        v-if="column.dataFieldName === 'actions'"
        :class="$style.buttonProperty"
      >
        <ButtonGroup
          v-for="(item, buttonIndex) in itemData.actions"
          :key="buttonIndex"
          :class="$style.iconButtons"
          :isFullWidth="false"
        >
          <IconButton
            :aria-label="item.toolTipText"
            hasNoBackground
            :icon="item.icon"
            :text="item.toolTipText"
            @click="callAction(item.click, itemData.id, itemData)"
          />
        </ButtonGroup>
      </span>
      <span v-else>
        <div v-if="column.dataFieldName === 'lastName'">
          <div :class="$style.colorClass">{{ itemData[column.dataFieldName] }} </div>
          <div :class="$style.names">{{ itemData.userName }} </div>
        </div>
        <div v-else-if="column.dataFieldName === 'linklastName'">
          <Link
            :class="$style.name"
            data-test-id="InvestigativePage_UserName"
            :href="getUserNameHref()"
            :text="itemData[column.dataFieldName]"
          />
          <div :class="$style.names">{{ itemData.userName }} </div>
        </div>
        <div v-else-if="column.dataFieldName === 'action'">
          <ButtonLink
            :class="$style.name"
            data-test-id="InvestigativePage_Action"
            :text="itemData[column.dataFieldName]"
            @click="callAction('getManualGroupMembership', itemData.id, itemData)"
          />
          <div :class="$style.names">{{ itemData.userName }} </div>
        </div>
        <div v-else-if="column.dataFieldName === 'groupname'">
          <Link
            :class="$style.name"
            data-test-id="InvestigativePage_GroupName"
            :href="getGroupHref()"
            :text="itemData[column.dataFieldName]"
          />
        </div>
        <div v-else>{{ itemData[column.dataFieldName] }} </div>
      </span>
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  ButtonGroup,
  ButtonLink,
  IconButton,
  ItemRow,
  ItemWithLabel,
  Link,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import { mapActions } from 'vuex';
import InvestigativePageMixin from 'client/HomePageV2/mixins/InvestigativePageMixin';
import SegmentEventMixin from 'client/HomePageV2/mixins/SegmentEventMixin';
import Util from 'client/util/Util';

const administratorModel = 'AdministratorModel';

export default {
  name: 'RowData',

  components: {
    ButtonLink,
    ButtonGroup,
    IconButton,
    ItemWithLabel,
    ItemRow,
    Link,
  },

  mixins: [
    InvestigativePageMixin,
    SegmentEventMixin,
  ],

  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    itemData: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...mapActions(administratorModel, ['resetActionKey']),

    async callAction(action, id, itemObject = {}) {
      this.triggerViewAllButtonClickedHandler(action);

      // When a action click is made on each row the id is passed as a string
      // Pushing the selected id into a temp array as the api expects an array type
      const itemsIds = [];
      itemsIds.push(id);
      switch (action) {
        case 'handleExportCsv':
          await this.reportExport('csv', itemObject);
          break;
        case 'handleExportJson':
          await this.reportExport('json', itemObject);
          break;
        case 'handleUnlock':
          await this.handleUnlock(itemsIds);
          break;
        case 'handleSuspend':
          await this.handleSuspend(itemsIds);
          break;
        case 'handlePasswordChange':
          await this.handlePasswordChange(itemsIds);
          break;
        case 'sendSelectedUsersEmailContinue':
          await this.sendSelectedUsersEmailContinue(itemsIds);
          break;
        case 'getManualGroupMembership':
          await this.getGroupIdAndRefresh(itemObject);
          break;
        default: break;
      }
      await this.resetActionKey();
    },

    getGroupHref() {
      const url = `${ItemTypeRoutes[ItemTypeConsts.userGroup]}/${this.itemData.groupid}/details`;
      return url;
    },

    getUserNameHref() {
      return Util.getChildUserOrgUrl(this.itemData);
    },
  },

};
</script>
<style module>
.buttonProperty {
  display: inline-flex;
}

.iconButtons {
  padding-right: 1rem;
}

.names {
  font-size: 0.8rem;
}
</style>
